import React, { FunctionComponent, useState, useRef } from "react";
import {
  Fab,
  Button,
  Grid,
  Table,
  Typography,  
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import DescriptionIcon from "@material-ui/icons/Description";
import Tooltip from "@material-ui/core/Tooltip";
import PrintIcon from "@material-ui/icons/Print";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ReactToPrint from "react-to-print";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import "../Print.css";
import { eodItemStyles } from "../eodItemStyles";
import { api } from "../../../api";
import { ThemeProvider } from "@mui/material/styles";
import { useTableStyles } from "../../useTableStyle";
import { useStore } from "../../../store";
import { FinancialReport } from "../EodFinancialReport/FinancialReport";
import { FinancialReportView } from "../EodFinancialReport/FinancialReportView";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = [
  "Date",
  "Document No",
  "Gross Sales",
  "Net Sales",
  "Total Discount",
  "",
];

const tableOptions = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

type eodProps = {
  handleSearch: () => void;
};

export const EodTableList: FunctionComponent<eodProps> = ({ handleSearch }) => {
  const classes = eodItemStyles();
  const getMuiTheme = useTableStyles();
  const componentRef = useRef<any>(null);
  const [eods] = useStore("eods");

  const [openFlag, setOpenFlag] = useState<boolean>(false);
  const [eodData, setEodData] = useState<object>();
  const [eodUserData, setEodUserData] = useState<object>();
  

  const ReactWaterMark = require("react-watermark-component");
  
  
  const options = {
    chunkWidth: 1200,
    chunkHeight: 1100,
    textAlign: "left",
    textBaseline: "bottom",
    globalAlpha: 0.17,
    font: "80px Microsoft Yahei",
    rotateAngle: -0.33,
    fillStyle: "#666",
  };

  const getDetails = async (id: string) => {
    try {
      const details = await api.get(`eod/${id}/report-details`);
      if (details !== undefined) {
        setEodData(details.transaction_data);
        setEodUserData(details.user);
        setOpenFlag(true);
        handleSearch();
      }
    } catch (error) {
      console.log("error");
    }
  };

  if (eods && eods.length > 0) {
    return (
      <div>
        {openFlag === false ? (
          <Table>
            <ThemeProvider theme={getMuiTheme}>
              <MUIDataTable
                title={"Eod List"}
                data={eods.map((eod: any) => {
                  return [
                    moment(eod.bod_date).format("DD/MM/YYYY  h:mm:ss A"),
                    eod.eod_businessdayid,
                    eod.gross_sales,
                    eod.net_sales,
                    eod.discount_amt_total,
                    <Grid container direction="row" spacing={2}>
                      <Grid item>
                        <Tooltip title="View Details">
                          <Fab
                            size="small"
                            aria-label="details"
                            color="primary"
                            className={classes.detailIconMargin}
                            onClick={() => getDetails(eod.eod_businessdayid)}
                          >
                            <DescriptionIcon className={classes.detailIcon} />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>,
                  ];
                })}
                columns={columns}
                options={tableOptions}
              />
            </ThemeProvider>
          </Table>
        ) : (
          <Paper className={classes.paper} elevation={0}>
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
              spacing={3}
            >
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => setOpenFlag(false)}
                >
                  <ArrowBackIcon />
                  Back
                </Button>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="center"
              spacing={3}
            >
              <Grid item>
                <Typography
                  style={{
                    fontSize: "1.3rem",
                    color: "black",
                    fontWeight: "bolder",
                  }}
                >
                  Do you want to print the Report ?{" "}
                </Typography>
              </Grid>
              <Grid item>
                 <ReactToPrint
                  trigger={() => (
                    <Button variant="contained" color="primary" size="medium" >
                      <PrintIcon />
                      Print
                    </Button>
                   )}
                  content={() => componentRef.current}
                  pageStyle="@page { size:  5.8 in 8.3in;margin:1cm;}"
                /> 
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <ReactWaterMark
                waterMarkText={"Duplicate Copy"}
                options={options}
              >
                <FinancialReportView
                  eodReportDetails={eodData}
                  userData={eodUserData}
                  detailFlag={true}
                />
              </ReactWaterMark>
            </Grid>
            <Grid item lg={12} style={{ display: "none" }}>
              <div ref={componentRef}>
                <ReactWaterMark
                  waterMarkText={"Duplicate Copy"}
                  options={options}
                >
                  <FinancialReport
                    eodReportDetails={eodData}
                    ref={componentRef}
                    userData={eodUserData}
                    detailFlag={true}
                  />
                </ReactWaterMark>
              </div>
            </Grid>
          </Paper>
        )}
      </div>
    );
  } else {
    return (
      <div>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Eod List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
